import * as React from 'react'

import { Button, type Icon } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'

interface Props {
  illustration: React.ComponentProps<typeof Icon.Large>['icon']
  title: string
  description: string
  nameLabel: string
  namePlaceholder: string
  submitButton: string
  onClose: () => void
  onSubmit: (name: string) => Promise<any>
}

export class SchemaForm extends Form {
  constructor(values: object) {
    super(values, {
      name: 'string',
    })
  }
}

const NewModal = ({
  illustration,
  title,
  description,
  nameLabel,
  namePlaceholder,
  submitButton,
  onClose,
  onSubmit,
}: Props) => {
  const form = React.useRef(
    new SchemaForm({
      name: '',
    })
  ).current

  const { running, performAction } = useAsyncAction(async (closePortal: ClosePortalFn) => {
    await onSubmit(form.get('name').value)
    closePortal()
  })

  return (
    <Modal
      illustration={illustration}
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={performAction}
      footer={
        <Button disabled={!form.isDirty || running} submit>
          {submitButton}
        </Button>
      }
    >
      <FormRow>
        <Text label={nameLabel} placeholder={namePlaceholder} field={form.get('name')} />
      </FormRow>
    </Modal>
  )
}

export default observer(NewModal)
